"use strict";
// import FastRTCPeer, {
//   DATA,
//   DATA_CLOSE,
//   DATA_OPEN,
//   DataPayload,
//   DispatchPayload,
//   ERROR,
//   SIGNAL,
// } from '@mattkrick/fast-rtc-peer'
// import Trebuchet, {Data, TrebuchetSettings} from './Trebuchet'
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=WRTCTrebuchet.js.map